import * as yup from "yup";
// utils
import axios from "../utils/axios";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const nameReg = /^[a-zA-Z ]{1,30}$/;
export const registerSchema = yup.object().shape({
  first_name: yup
    .string()
    .trim()
    .required("Please enter first name.")
    .max(30, "Only 30 characters allowed")
    .matches(nameReg, "No numeric and special characters allowed."),
  last_name: yup
    .string()
    .trim()
    .required("Please enter last name.")
    .max(30, "Only 30 characters allowed")
    .matches(nameReg, "No numeric and special characters allowed."),
  // username: yup.string().required("Please enter username."),
  email: yup
    .string()
    .trim()
    .email("Email should be valid and contain @")
    .required("Please enter email.")
    .max(50, "Only 50 characters allowed")
    .test(
      "Unique Email",
      "Email already in use", // <- key, message
      function (value) {
        return new Promise((resolve, reject) => {
          axios
            .post(`check-available-email`, { email: value })
            .then((res) => {
              resolve(true);
            })
            .catch((error) => {
              if (error.message === "The email has already been taken.") {
                resolve(false);
              }
            });
        });
      }
    ),
  // mobile: yup
  //   .string()
  //   .required("Please enter mobile number.")
  //   .matches(phoneRegExp, "Mobile number is not valid")
  //   .min(10, "to short")
  //   .max(10, "to long"),

  mobile: yup
    .string()
    .required("Please enter mobile number.")
    .matches(phoneRegExp, "Mobile number is not valid.")
    .test(
      "Unique Mobile Number",
      "Mobile number already in use", // <- key, message
      function (value) {
        const userMobile = localStorage.getItem("registerMobile");
        return new Promise((resolve, reject) => {
          axios
            .post(`check-available-mobile`, { mobile: userMobile })
            .then((res) => {
              resolve(true);
            })
            .catch((error) => {
              if (error.message === "The mobile has already been taken.") {
                resolve(false);
              }
            });
        });
      }
    ),
  pincode: yup
    .string()
    .trim()
    .required("Please enter pincode")
    .matches(/^(\d{5}|\d{6})$/, "Please enter valid pincode"),
  // phone: yup.mixed().test("phone", "Error", value => {
  //   console.log(value)
  // }),
  // phone: yup.mixed().required("Please enter mobile number.").test("phone", "Error", value => {
  //   console.log(value)
  // }),
  // businessType: yup.string().required("Business type is required"),
  password: yup
    .string()
    .trim()
    .required("Please enter password")
    .min(8, "Password must be at least 8 characters.")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      "Password must be at least 8 characters, including 1 uppercase, 1 lowercase, 1 number and 1 special (!@#$%^&) character"
    ),
  password_confirmation: yup
    .string()
    .required("Please enter confirm password")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});
